<template>
  <el-dropdown trigger="click" @command="handleCommand" class="lang-switch">
    <span class="lang-label">
      <span class="current-lang">{{ getCurrentLangText()  }}</span>
      <i class="el-icon-arrow-down"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="zh" :class="{ active: currentLang === 'zh' }">
        <span class="lang-option">中文-ZH</span>
      </el-dropdown-item>
      <el-dropdown-item command="en" :class="{ active: currentLang === 'en' }">
        <span class="lang-option">English-EN</span>
      </el-dropdown-item>
      <el-dropdown-item command="ja" :class="{ active: currentLang === 'ja' }">
        <span class="lang-option">日本語-JP</span>
      </el-dropdown-item>
      <el-dropdown-item command="ko" :class="{ active: currentLang === 'ko' }">
        <span class="lang-option">한국어-KO</span>
      </el-dropdown-item>
      <el-dropdown-item command="ru" :class="{ active: currentLang === 'ru' }">
        <span class="lang-option">Русский-RU</span>
      </el-dropdown-item>
      <el-dropdown-item command="es" :class="{ active: currentLang === 'es' }">
        <span class="lang-option">Español-ES</span>
      </el-dropdown-item>
      <el-dropdown-item command="fr" :class="{ active: currentLang === 'fr' }">
        <span class="lang-option">Français-FR</span>
      </el-dropdown-item>
      <el-dropdown-item command="ar" :class="{ active: currentLang === 'ar' }">
        <span class="lang-option">العربية-AR</span>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import {mapActions} from "vuex";
import { switchLanguage, getCurrentLanguage, getPathWithoutLanguage, generateLanguagePath } from '@/utils/routeUtils'

export default {
  name: 'LangSwitch',
  props: {
    isScrolled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentLang: localStorage.getItem('language') || 'zh'
    }
  },
  created() {
    this.$i18n.locale = this.currentLang
  },
  methods: {
    ...mapActions(['setLanguage']),
    getCurrentLangText() {
      const langMap = {
        'zh': 'ZH',
        'en': 'EN',
        'ja': 'JP',
        'ko': 'KO',
        'ru': 'RU',
        'es': 'ES',
        'fr': 'FR',
        'ar': 'AR'
      }
      return langMap[this.currentLang] || 'English'
    },
    handleCommand(value) {
      // 如果选择的是当前语言，不做任何操作
      if (value === this.currentLang) {
        return
      }

      // 更新语言状态
      this.setLanguage(value)
      this.currentLang = value
      this.$i18n.locale = value
      localStorage.setItem('language', value)

      // 使用多语言路由切换
      try {
        // 获取当前路径（不带语言前缀）
        const currentPath = this.$route.path
        const cleanPath = getPathWithoutLanguage(currentPath)

        // 生成新的多语言路径
        const newPath = generateLanguagePath(cleanPath, value)

        // 如果新路径与当前路径不同，则进行路由跳转
        if (newPath !== currentPath) {
          this.$router.push(newPath)
        }
      } catch (error) {
        console.warn('语言切换路由跳转失败:', error)
        // 如果路由跳转失败，刷新页面作为备用方案
        window.location.reload()
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';

.lang-switch {
  .lang-label {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s;
    
    .lang-icon {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
    
    .current-lang {
      font-size: 14px;
      color: inherit;
    }

    .el-icon-arrow-down {
      font-size: 12px;
      margin-left: 0;
      color: inherit;
    }
  }
}

:deep(.el-dropdown-menu) {
  min-width: 140px;
  padding: 5px 0;
  
  .el-dropdown-menu__item {
    padding: 8px 15px;
    font-size: 14px;
    color: #666;
    text-transform: lowercase;
    
    &.active {
      color: #19529F;

      background-color: rgba(25, 82, 159, 0.05);
    }
    
    &:hover {
      background-color: rgba(25, 82, 159, 0.1);
      color: #19529F;
    }
    
    .lang-option {
      display: block;
      text-align: left;
    }
  }
}
</style>

<style lang="less">
.header--scrolled {
  .lang-switch {
    .lang-label {
      .current-lang {
        color: #333;
      }
      .el-icon-arrow-down {
        color: #333;
      }
    }
  }
}
</style> 